import type {Permissions} from 'auth/PermissionConstants';
import type {EmptyPayload} from 'constants/events/EventPayloadUtils';
import type {WorkspaceItemDispatchItem} from 'constants/FileBrowserConstants';
import type {FolderSummary} from 'constants/FolderConstants';
import type {BioentityAliasInfo, TagSchema} from 'constants/RegistryConstants';
import type {NavStoreSource} from 'constants/SourceConstants';
import type {User} from 'constants/UserConstants';
import type {BioentitySummary, FileSummary, Tag} from 'folder-items/FileConstants';

export const FILE_BROWSER_EVENT_PAYLOADS = {
  FILE_BROWSER_MOVE_FILES_COMPLETED: {} as {
    ids: Array<string>;
    folder: FolderSummary | undefined | null;
    permissionsById?: Record<string, Permissions>;
  },
  FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED: {} as {
    ids: Array<string>;
    folder: FolderSummary | undefined | null;
  },
  FILE_BROWSER_RENAME_FILE: {} as {
    id: string;
    name: string;
    displayLabel?: string;
    bioentityAliasInfos?: Array<BioentityAliasInfo>;
  },
  FILE_BROWSER_RENAME_FILE_FAILED: {} as EmptyPayload,
  FILE_BROWSER_ITEMS_DELETED: {} as {
    ids: Array<string>;
  },
  FILE_BROWSER_SOURCE_DELETED: {} as {
    id: string;
  },
  FILE_BROWSER_SOURCE_UPDATED: {} as {
    sourceId: string;
    sourceUpdates: Partial<NavStoreSource>;
  },
  FILE_BROWSER_SOURCES_FETCHED: {} as {sources: Array<NavStoreSource>},
  FILE_BROWSER_RECENTS_FETCHED: {} as {recents: Array<FileSummary>},
  FILE_BROWSER_ADD_TO_WORKSPACE: {} as {
    fileId: string;
    item: WorkspaceItemDispatchItem;
  },
  FILE_BROWSER_BULK_REMOVE_FROM_WORKSPACE: {} as {
    fileIds: Array<string>;
  },
  FILE_BROWSER_REMOVE_FROM_WORKSPACE: {} as {
    fileId: string;
  },
  FILE_BROWSER_MOVE_WORKSPACE_TAB: {} as {
    workspaceItemId: string;
    toIndex: number;
  },
  FILE_BROWSER_CLEAR_WORKSPACE: {} as {
    itemIdsToKeep: Array<string>;
  },
  FILE_BROWSER_UNREGISTER_FILES: {} as {
    ids: Array<string>;
    parentFolderIds: Array<string>;
  },
  SOURCES_UPDATED_FROM_GRAPHQL: {} as {
    sources: Array<NavStoreSource>;
  },

  FILES_FETCH_COMPLETED: {} as {
    fileSummariesById: {[id: string]: BioentitySummary};
    inaccessibleFileIds: Array<string>;
  },
  FOLDER_INVALIDATED: {} as EmptyPayload,

  FILE_AUTHORS_UPDATED: {} as {
    fileId: string;
    authors: Array<User>;
    newPermissions: Permissions;
  },
  FILE_TAGS_UPDATE_STARTED: {} as EmptyPayload,
  FILE_TAGS_UPDATED: {} as {
    tagData: Array<{id: string; tags: Array<Tag>}>;
  },
  FILE_TAGS_UPDATE_FAILED: {} as EmptyPayload,
  // TODO(T6458): Get rid of this event
  FILE_TAGS_WITH_FINDER_UPDATED: {} as {
    finderId: string;
    tagData: Array<{id: string; tags: Array<Tag>}>;
  },
  FILE_TAG_SCHEMA_UPDATED: {} as {
    fileId: string;
    tagSchema: TagSchema | null;
    tags: Array<Tag>;
  },

  SOURCE_ADD_AUDITOR_COMPLETED: {} as EmptyPayload,
  SOURCE_REMOVE_AUDITOR_COMPLETED: {} as EmptyPayload,
} as const;

export type FileBrowserEventPayload = typeof FILE_BROWSER_EVENT_PAYLOADS;
